export const closeOutlineIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.4-1.4A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.5L11.4 10l2.83 2.83-1.4 1.4L10 11.4l-2.83 2.83-1.4-1.4L8.6 10 5.76 7.17l1.4-1.4L10 8.6l2.83-2.83 1.4 1.4z"/></svg>`,
  name: 'close-outline',
};
